module.exports = require("./lib/_stream_transform.js")



/*****************
 ** WEBPACK FOOTER
 ** (webpack)/~/stream-browserify/~/readable-stream/transform.js
 ** module id = 4165
 ** module chunks = 0
 **/